module.exports = {
      id: "comm-gadgets-usage",
      viewBox: "0 0 320 56.865",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comm-gadgets",
      toString: function () {
        return this.url;
      }
    }